import { render, staticRenderFns } from "./newsCollect.vue?vue&type=template&id=4fa3b1a6"
import script from "./newsCollect.vue?vue&type=script&lang=js"
export * from "./newsCollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports